import React from 'react';
import { Col, Row } from '../../../lib/utils';
import { colors } from '../../../lib/colors';
import { Body3Regular } from '../../../lib/font';
import ProfileImage from '../../ProfileImage';

import {
    I_LEFT_ANGLE_BRACKET_DEFAULT,
    I_LEFT_ANGLE_BRACKET_HOVER,
    I_LEFT_ANGLE_BRACKET_CLICK,
    I_RIGHT_ANGLE_BRACKET_DEFAULT,
    I_RIGHT_ANGLE_BRACKET_HOVER,
    I_RIGHT_ANGLE_BRACKET_CLICK,
} from '../../../types/images';
import styled from 'styled-components';

const LeftLogoButtonWrap = styled.button`
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 32px;
    height: 32px;
    right: 0;
    top: 50%;
    transform: translateY(-50%);

    border: none;
    background: none;
    padding: 0;
    cursor: pointer;

    img {
        width: 32px;
        height: 32px;
        transition: all 0.2s ease-in-out;
    }

    &:hover img {
        content: url(${I_LEFT_ANGLE_BRACKET_HOVER});
    }

    &:active img {
        content: url(${I_LEFT_ANGLE_BRACKET_CLICK});
    }
`;

// const RightLogoButtonWrap = styled.button`
//     position: absolute;
//     display: flex;
//     flex-direction: row;
//     align-items: center;
//     width: 32px;
//     height: 32px;
//     left: calc(50% + 20px);
//     transform: 'translateX(0)'

//     border: none;
//     background: none;
//     padding: 0;
//     cursor: pointer;

//     img {
//         width: 32px;
//         height: 32px;
//         transition: all 0.2s ease-in-out;
//     }

//     &:hover img {
//         content: url(${I_RIGHT_ANGLE_BRACKET_HOVER});
//     }

//     &:active img {
//         content: url(${I_RIGHT_ANGLE_BRACKET_CLICK});
//     }
// `;

const RightLogoButtonWrap = styled.button`
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 32px;
    height: 32px;
    right: 0; /* 오른쪽에 붙이기 위한 설정 */
    top: 50%;
    transform: translateY(-50%); /* 세로 중앙 정렬 */

    border: none;
    background: none;
    padding: 0;
    cursor: pointer;

    img {
        width: 32px;
        height: 32px;
        transition: all 0.2s ease-in-out;
    }

    &:hover img {
        content: url(${I_RIGHT_ANGLE_BRACKET_HOVER});
    }

    &:active img {
        content: url(${I_RIGHT_ANGLE_BRACKET_CLICK});
    }
`;

const OrderChangeButton = styled.button`
    display: inline-flex;
    padding: 4px 12px;
    justify-content: center;
    align-items: center;
    gap: 8px;

    border-radius: 48px;
    border: 1px solid #868686;
    background: #fdfeff;
    color: #6b7280;
    font-size: 12px;
    font-weight: 400;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
        border-color: #6b7280;
        color: #4b5563;
    }

    &:active {
        border-color: #4b5563;
        color: #374151;
    }
`;

const CoachHeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1px;
`;

const CoachScheduleCount = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 52px;
    height: 18px;
    padding: 0 7px;
    border-radius: 9px;
    color: #466699;
    background: #edf3ff;
    font-size: 10px;
    font-weight: 750;
    line-height: 1;
    white-space: nowrap;
`;

const CoachList = ({
    dailyCurrentData,
    scheduleCountByCoach = {},
    scrollY,
    currentPage,
    endPage,
    handleNextPage,
    handlePrevPage,
    handleOrderChange,
}: any) => {
    return (
        <Row
            style={{
                width: '100%',
                height: 90,
                marginTop: 0,
                backgroundColor: colors.WHITE_50,
                border: '1px solid #A6BFEF',

                position: 'fixed',

                // ScheduleTop(고정바) 바로 아래(164)에 헤더 고정. 주간 WeekList와 동일하게 맞춤.
                top: 164,
                // transition: 'all 0.3s ease',
                left: 0,
                zIndex: 3,
            }}
        >
            <Row
                className={'first test!'}
                style={{
                    width: '7.5%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                }}
            >
                <OrderChangeButton onClick={handleOrderChange}>순서 변경</OrderChangeButton>
                {endPage > 1 && currentPage > 1 ? (
                    <LeftLogoButtonWrap onClick={handlePrevPage} aria-label="이전 강사 페이지">
                        <img style={{ width: 32, height: 32 }} src={I_LEFT_ANGLE_BRACKET_DEFAULT} alt="이전 페이지" />
                    </LeftLogoButtonWrap>
                ) : null}
            </Row>
            {dailyCurrentData &&
                dailyCurrentData.map((item: any, index: number) => {
                    const scheduleCount = scheduleCountByCoach[String(item.coachId)] || 0;
                    return (
                        <Col
                            className={`test!~${index}`}
                            style={{
                                position: 'relative',
                                width: '11.5%',
                                display: 'flex',
                                flexDirection: 'column', // 세로 방향으로 정렬
                                alignItems: 'center', // 가로 방향에서 중앙 정렬
                                justifyContent: 'center', // 세로 방향에서 중앙 정렬
                            }}
                            key={index + 'dailySchedules'}
                        >
                            <CoachHeaderContent>
                                <ProfileImage
                                    imageUrl={item?.coachProfileImageUrl}
                                    type="Small"
                                    profileName={item?.coachProfileName}
                                    profileColorType={item?.coachProfileColorType}
                                />
                                <Body3Regular style={{ color: colors.LAVEL_3 }}>{item.coachName}</Body3Regular>
                                <CoachScheduleCount aria-label={`${item.coachName} ${scheduleCount}개 일정`}>
                                    {scheduleCount}개 일정
                                </CoachScheduleCount>
                            </CoachHeaderContent>

                            {currentPage < endPage && index === dailyCurrentData.length - 1 ? (
                                <RightLogoButtonWrap onClick={handleNextPage} aria-label="다음 강사 페이지">
                                    <img
                                        style={{ width: 32, height: 32 }}
                                        src={I_RIGHT_ANGLE_BRACKET_DEFAULT}
                                        alt="다음 페이지"
                                    />
                                </RightLogoButtonWrap>
                            ) : null}
                        </Col>
                    );
                })}
        </Row>
    );
};

export default CoachList;
